import React from 'react';
import { Layout } from '../../components/layout/Layout';
import Grade3AssignmentPage from '../Grade3AssignmentPage';

/** Authenticated Grade 3 workbook; same component as public `/demo/grade3-assignments`. */
export const StudentActivityPage: React.FC = () => {
  return (
    <Layout noPadding>
      <Grade3AssignmentPage />
    </Layout>
  );
};
